export default __webpack_public_path__ + "static/media/search.e2b9a848.svg";